import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const CheckboxStyled = styled.div`
  padding-right: 15px;
  user-select: none;
  ${props => props.toggle && `
    display: flex;
    padding: 0;
  `}

  input[type="checkbox"] {
    position: absolute;
    left: -9999px;
  }

  input[type="checkbox"] + label {
    position: relative;
    padding-left: 25px;
    cursor: pointer;
    color: #fff;
    ${props => props.toggle && `
      width: 100%;
      padding: 10px 0 10px 25px;
    `}
  }

  input[type="checkbox"] + label::before {
    content: '';
    position: absolute;
    ${props => (props.toggle ? `
      top: 12px;
      left: 0;
    ` : `
      left: 0;
      top: 2px;
    `)}
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 0.6);
  }

  input[type="checkbox"] + label::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMnB4IiBoZWlnaHQ9IjlweCIgdmlld0JveD0iMCAwIDEyIDkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+UGFnZSAxPC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9Im5ldyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0idXNlciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExOS4wMDAwMDAsIC0zMC4wMDAwMDApIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9IiNGRkZGRkYiPiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYWdlLTEiIHBvaW50cz0iMTIwLjM1MzU1MyAzMy41Njg1NTY2IDExOS42NDY0NDcgMzQuMjc1NjYzNCAxMjMuNTk0MDI3IDM4LjIyMzI0NDIgMTMwLjQwMjU4MSAzMS40MTM2MzYgMTI5LjY5NTQxOSAzMC43MDY1ODQgMTIzLjU5Mzk3MyAzNi44MDg5NzU4Ij48L3BvbHlnb24+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=);
    position: absolute;
    ${props => (props.toggle ? `
      top: 11px;
      left: 0;
    ` : `
      top: 0;
      left: 0;
    `)}
    width: 16px;
    height: 16px;
    line-height: 14px;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    opacity: 0;
    transform: scale(0);
  }

  input[type="checkbox"]:checked + label::after {
    opacity: 1;
    background-color: ${COLORS.primary};
    transform: scale(1);
  }

  input[type="checkbox"]:disabled + label::before {
    opacity: 0.7;
  }

  input[type="checkbox"]:disabled:checked + label::after {
    opacity: 0.4;
  }

  input[type="checkbox"]:disabled + label {
    opacity: 0.4;
  }
`;

export default CheckboxStyled;
